import {
  Message
} from '@ktw/kcore';
import {
  ConfigLoader
} from '@ktw/kutil';

//应用程序配置
let config;
try {
  config = ConfigLoader.readAndConvertSync('./config/app.xml');
} catch (e) {
  Message.error(e);
}

export default config;
